import { Http, Headers } from '@angular/http';
import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { StateService } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { ApiAuthStore } from '../store/api.auth.store';
import { UtilService } from '../util.service';
@Injectable()
export class ApiLogoutService extends ApiBaseService {

  protected headers: Headers;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    super(app, events, http, plt, stateService, alertService, toastService, loadingCtrl, toastController, apiAuthStore, utilService);
  }


  /**
   * ログアウト
   * 
   * @param params
   * @return void
   */
  post(): Promise<any> {

    let loading = this.loadingCtrl.create({
      content: 'ログアウト中...'
    });
    loading.present();

    return new Promise((resolve) => {
      return this.doPost({
        url: this.apiAuthStore.url + '/api/v1/logout',
        body: {},
        headers: this.headers
      }).finally(
        () => loading.dismiss()
      ).subscribe(
        response => {
          resolve(response)
        }
      )
    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-logout.service.ts